import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { BrugerNotifikation } from '@features/brugere/bruger-notifikationer/bruger-notifikationer.model';

@Injectable({
  providedIn: 'root'
})
export class BrugerNotifikationApi extends RestApi<BrugerNotifikation> {
  override endpoint = '/v2/brugernotifikationer';

}
